import './message.css';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {'notice' | 'error' | 'success'} [props.type=notice]
 * @param {string} [props.message]
 */
export default function Message({ type = 'notice', message, useDangerousHtml }) {
	return (
		<div class={'message-container' + (type ? ' message-type-' + type : ' message-type-notice')} dangerouslySetInnerHTML={(useDangerousHtml ? { __html: message } : false)}>
			{!useDangerousHtml ? <p>
				{message}
			</p> : ''}
		</div>
	);
}
